<template>
    <b-container class="hkiarace-event-category-list">
        <b-row>
            <b-col>
                <h2>{{this.title || $t('admin_event_category.title')}}</h2>
                <b-button id="addEventCategoryBtn" variant="primary" @click="addEventCategory">{{$t('admin_event_category.add_category')}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table :items="eventCategories"
                         :fields="eventCategoryFields"
                         :selectable="!!onSelect"
                         select-mode="single"
                         responsive
                         show-empty
                         empty-text="No Item Categories"
                         tbody-class="hkiarace-event-category-list-table-body">
                    <template v-slot:cell(color)="data">
                        <b-button pill :style='{"background-color": data.item.color || "#222222", "border": "none", "cursor": "default"}'></b-button>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <font-awesome-icon icon="edit"
                                           v-b-tooltip.hover title="Detail"
                                           @click="showEventCategoryDetail(data.item)"></font-awesome-icon>
                        <font-awesome-icon icon="trash"
                                           v-b-tooltip.hover title="Delete Item Category"
                                           @click="deleteEventCategory(data.item)"></font-awesome-icon>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faEdit, faSearch} from '@fortawesome/free-solid-svg-icons'

    library.add(faEdit, faSearch);

    export default {
        name: 'HkiaraceEventCategoryList',
        props: {
            title: String,
            onSelect: Function,
        },
        data() {
            let v = this;
            return {
                eventCategories: [],
                eventCategoryFields: [
                    {key: 'name_en', label: this.$t('admin_event_category.name_en')},
                    {key: 'name_zh', label: this.$t('admin_event_category.name_zh')},
                    {key: 'color', label: this.$t('admin_event_category.color')},
                    {
                        key: 'layout_style', label: this.$t('admin_event_category.layout_style'),
                        formatter(value, key, item) {
                            return {
                                1: v.$t('admin_event_category.layout_style_list'),
                                2: v.$t('admin_event_category.layout_style_grid'),
                            }[item.layout_style];
                        },
                    },
                    {key: 'actions', label: ''},
                ],
            }
        },
        mounted() {
            this.getEventCategories();
        },
        methods: {
            getEventCategories() {
                this.$callAPI('hkiarace/event_category/', {}, function (response) {
                    this.eventCategories = response.body.categories;
                });
            },
            addEventCategory() {
                this.$router.push({name: 'hkiarace-event-category-add'});
            },
            showEventCategoryDetail(eventCategory) {
                this.$router.push({name: 'hkiarace-event-category-detail', params: {eventCategoryId: eventCategory.id}});
            },
            deleteEventCategory(eventCategory) {
                if (confirm(this.$t('admin_event_category.confirm_delete_category'))) {
                    this.$callAPI('hkiarace/event_category/delete/', {id: eventCategory.id}, function () {
                        this.getEventCategories();
                    })
                }
            },
        },
    }
</script>

<style scoped lang="less">
    #addEventCategoryBtn {
        position: absolute;
        top: 0;
        right: 30px;
    }

    .hkiarace-event-category-list-table-body {
        svg {
            font-size: 1.5em;
            margin-left: 5px;
        }

        .fa-edit, .fa-trash {
            cursor: pointer;
            &:hover {
                color: #0070ff;
            }
        }
    }
</style>
